<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="uppercase font-jost-medium text-blue-dark text-base">{{ transaction.chainName }} Transaction</h2>
    <div class="flex items-center justify-between">
      <!-- Left Side: Status + Transaction Type -->
    <!-- <div class="flex items-center gap-3">
      <span class="px-2 py-1 text-base font-medium rounded uppercase" 
          :class="transaction.status === 'valid' ? 'bg-green-100 text-green-800' : 
            transaction.status === 'invalid' ? 'bg-red-100 text-red-800' : 
            'bg-yellow-100 text-yellow-800'">
        {{ transaction.status || 'PENDING' }}
      </span>
    </div> -->
    
    <!-- Middle: Transaction Details -->
    <div class="flex-1 flex items-center gap-[50px] min-w-0">
      <!-- Hash - Truncated -->
      <div class="flex items-center min-w-0 flex-2">
        <span class="text-[#6B7280] font-medium mr-1 text-base">Hash:</span>
        <router-link
          v-if="transaction && transaction.value"
          :to="{ name: 'transaction', params: { chainNumber: transaction.chainNumber, txRefhash: transaction.value } }"
          class="text-[#374151] font-jost-regular text-base break-all"
          :title="transaction.value"
        >
          {{ transaction.value }}
        </router-link>
        <span v-else class="text-[#374151] font-jost-regular text-base">N/A</span>
      </div>
      
      <!-- Chain name -->
      <!-- <div class="flex items-center gap-2 text-base flex-2">
        <span class="text-[#6B7280]">Chain Name:</span>
        <RouterLink :to="{ name: 'chain', params: { chainNumber: transaction.chainNumber } }" class="text-[#374151] font-jost-regular" :title="transaction.chainName || 'N/A'">
          {{ transaction.chainName || 'N/A' }}
        </RouterLink>
      </div> -->
      
      <!-- From/To - Very compact -->
      <!-- <div class="flex items-center gap-2 text-base flex-2">
        <span class="text-[#6B7280]">From:</span>
        <router-link v-if="transaction.from" :to="{name: 'account', params: { chain: transaction.chainNumber, address: transaction.from }}"
          class="text-[#374151] font-jost-regular text-base">
            <span class="text-[#374151] font-jost-regular" :title="transaction.from || 'N/A'">
              {{ truncateAddress(transaction.from) || 'N/A' }}
            </span>
        </router-link>
        
        <span class="text-[#6B7280]">→</span>
         <router-link v-if="transaction.to" :to="{name: 'account', params: { chain: transaction.chainNumber, address: transaction.to }}"
            class="text-[#374151] font-jost-regular text-base">
              <span class="text-[#374151] font-jost-regular" :title="transaction.to || 'N/A'">
                {{ truncateAddress(transaction.to) || 'N/A' }}
              </span>
        </router-link>
        </div>
      </div> -->
      
      <!-- Right Side: Value + Time -->
      <!-- <div class="flex items-center gap-4 text-base">
        <div class="text-right">
          <div class="text-[#374151] font-semibold">
            {{ transaction.amount || '0' }} {{ transaction.symbol || 'GEEQ' }}
          </div>
        </div>
        <div class="text-right min-w-[120px]">
          <div class="text-[#374151]">
            {{ transaction.createdAt ? formatDateTime(transaction.createdAt) : 'N/A' }}
          </div>
        </div> -->
      </div>
    </div>
  </li>
</template>

<script>
import { 
  formatDateTime, 
  truncateAddress
 } from '@/helpers/common';

export default {
  name: 'TransactionCard',
  props: {
    transaction: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    },
  }
}
</script>

<style scoped>
.transaction-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
</style>